import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DatosCompartidosService } from './datos-compartidos.service';

@Injectable({
  providedIn: 'root'
})
export class ParametroServices {

  constructor( 
    private _htpp:HttpClient,
    private _DatoConpartido:DatosCompartidosService
    ) { }

  getPrametro(id:any){
    console.log('prueba')
    //var para='URL_DIRECTION_SERVICE'
    this.requestParametro(id).subscribe((data:any)=>{
      this._DatoConpartido._Parametro.next(data);
    })
    
  }

  requestParametro(parametro:any){
    
    const url = environment.URL_BASE+'/parametro/ParametroAll?id='+parametro
    return this._htpp.get(url);
  }
}
